var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulherCaneta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 497,
    viewBox: "0 0 667 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17386_184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.666 436.927H0.000976562V436.594H666.666V436.927Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5544 0.333809C54.541 0.333809 51.2767 3.59812 51.2767 7.61058V369.518C51.2767 373.531 54.5406 376.796 58.5544 376.796L316.019 376.795C320.029 376.795 323.295 373.532 323.295 369.518V7.61058C323.295 3.59767 320.029 0.333809 316.019 0.333809H58.5544ZM316.019 377.129H58.5544C54.3575 377.129 50.9434 373.715 50.9434 369.518V7.61058C50.9434 3.41457 54.3575 0.000449877 58.5544 0.000449877L316.019 0C320.213 0 323.628 3.41457 323.628 7.61058V369.518C323.628 373.715 320.213 377.129 316.019 377.129Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.949 0.333809C342.937 0.333809 339.673 3.59812 339.673 7.61058V369.518C339.673 373.531 342.937 376.796 346.949 376.796L604.414 376.795C608.426 376.795 611.691 373.532 611.691 369.518V7.61058C611.691 3.59767 608.426 0.333809 604.414 0.333809H346.949ZM604.414 377.129H346.949C342.753 377.129 339.34 373.715 339.34 369.518V7.61058C339.34 3.41457 342.753 0.000449877 346.949 0.000449877L604.414 0C608.61 0 612.024 3.41457 612.024 7.61058V369.518C612.024 373.715 608.61 377.129 604.414 377.129Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.036 449.625H68.3735V449.291H103.036V449.625Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.573 446.007H193.538V445.674H253.573V446.007Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.426 462.006H104.37V461.673H185.426V462.006Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.294 459.766H572.647V459.432H598.294V459.766Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.777 459.766H487.055V459.432H560.777V459.766Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.019 454.136H342.729V453.803H442.019V454.136Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.187 320.952H153.414L148.996 269.989H221.769L226.187 320.952Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.956 320.952H157.183L152.765 269.989H225.538L229.956 320.952Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.131 310.008L164.704 280.931H215.59L218.016 310.008H167.131Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.809 436.591H262.42V320.952H272.809V436.591Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.086 436.591H268.873V320.952H276.086V436.591Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.541 333.715H276.086V320.952H175.541V333.715Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.095 436.591H168.707V333.715H179.095V436.591Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.374 436.591H175.159V333.715H182.374V436.591Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.153 436.591H94.7651V333.715H105.153V436.591Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.431 436.591H101.217V333.715H108.431V436.591Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.072 436.591H196.684V333.715H207.072V436.591Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.35 436.591H203.135V333.715H210.35V436.591Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.541 333.715H94.7651V320.952H175.541V333.715Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.645 209.659H92.0088V36.6196H393.645V209.659Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.708 209.659H95.7754V36.6196H401.708V209.659Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.645 209.659H92.0088V224.64H393.645V209.659Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.14 209.659H109.208V224.64H415.14V209.659Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.063 198.371V47.907H390.421V198.371H107.063Z",
    fill: "#F7F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.878 198.371L194.127 47.907H225.401L159.151 198.371H127.878Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.289 187.137C111.843 187.137 111.482 186.776 111.482 186.331V55.2508C111.482 54.805 111.843 54.4442 112.289 54.4442C112.734 54.4437 113.094 54.8054 113.094 55.2512V186.331C113.094 186.776 112.734 187.137 112.289 187.137Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.869 198.371L232.119 47.907H244.31L178.062 198.371H165.869Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.986 198.371V47.907H390.42V198.371H388.986Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.377 64.9259H401.708V52.2947H403.338L404.377 64.9259Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.708 64.9259H390.42V52.2947H401.708V64.9259Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.987 64.9259H236.816L242.379 52.2947H388.987V64.9259Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.063 64.9259H102.74L101.701 52.2947H107.063V64.9259Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.626 64.9259H217.907L223.469 52.2942H230.188L224.626 64.9259H224.626ZM186.634 64.9259H113.095V55.2508C113.095 54.805 112.734 54.4442 112.289 54.4442C111.843 54.4437 111.483 54.8054 111.483 55.2512V64.9259H107.063V52.2942H192.195L186.634 64.9259H186.634Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.907 64.9259H186.634L192.195 52.2947H223.468L217.907 64.9259Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 64.9258H111.482V55.2508C111.482 54.805 111.843 54.4442 112.289 54.4442C112.734 54.4437 113.094 54.8054 113.094 55.2512V64.9258Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.816 64.9259H224.625L230.187 52.2947H242.379L236.816 64.9259Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.42 64.9259H388.986V52.2947H390.42V64.9259Z",
    fill: "#E2E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.377 85.6418H401.708V73.0106H403.338L404.377 85.6418Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.708 85.6418H390.42V73.0101H401.708V85.6418ZM107.064 85.6418H102.741L101.702 73.0101H107.064V85.6418H107.064Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.987 85.6418H227.695L233.258 73.0101H388.987V85.6418ZM215.505 85.6418H208.786L214.347 73.0101H221.066L215.504 85.6418H215.505ZM177.512 85.6418H113.095V73.0101H183.074L177.513 85.6418H177.512ZM111.483 85.6418H107.063V73.0101H111.483V85.6418Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.785 85.6418H177.512L183.074 73.0106H214.347L208.785 85.6418Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 85.6418H111.482V73.0106H113.094V85.6418Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.695 85.6418H215.504L221.066 73.0106H233.257L227.695 85.6418Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.42 85.6418H388.986V73.0106H390.42V85.6418Z",
    fill: "#E2E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.377 106.358H401.708V93.7275H403.338L404.377 106.358Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.708 106.358H390.42V93.7275H401.708V106.358ZM107.064 106.358H102.741L101.702 93.7275H107.064V106.358H107.064Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.987 106.358H218.575L224.136 93.7275H388.986V106.358H388.987ZM206.383 106.358H199.665L205.226 93.7275H211.945L206.383 106.358ZM168.392 106.358H113.095V93.7275H173.953L168.391 106.358H168.392ZM111.483 106.358H107.063V93.7275H111.483V106.358Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.665 106.358H168.392L173.953 93.7275H205.226L199.665 106.358Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 106.358H111.482V93.7275H113.094V106.358Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.575 106.358H206.383L211.944 93.7275H224.137L218.575 106.358Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.42 106.358H388.986V93.7275H390.42V106.358Z",
    fill: "#E2E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.154 124.368H401.708V114.443H403.338L404.154 124.368Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.063 127.075H102.74L101.701 114.443H107.064V127.075H107.063ZM401.708 124.368H390.42V114.443H401.708V124.368Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.003 127.075H209.452L215.015 114.443H388.987V124.368H350.567C350.567 124.368 349.608 125.25 348.003 127.075H348.003ZM197.26 127.075H190.543L196.105 114.443H202.823L197.26 127.075ZM159.27 127.075H113.095V114.443H164.832L159.27 127.075H159.27ZM111.483 127.075H107.063V114.443H111.483V127.075Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.543 127.075H159.27L164.831 114.443H196.105L190.543 127.075Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 127.075H111.482V114.443H113.094V127.075Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.452 127.075H197.261L202.823 114.443H215.015L209.452 127.075Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.42 124.368H388.986V114.443H390.42V124.368Z",
    fill: "#E2E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.063 147.791H102.74L101.701 135.16H107.063V147.791Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.166 147.791H200.332L205.893 135.16H341.754C339.429 138.533 336.822 142.727 334.166 147.791L334.166 147.791ZM188.139 147.79H181.422L186.984 135.16H193.701L188.139 147.79ZM150.149 147.79H113.095V135.16H155.71L150.149 147.79H150.149ZM111.483 147.79H107.063V135.16H111.483V147.79Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.422 147.791H150.149L155.71 135.16H186.983L181.422 147.791Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 147.791H111.482V135.16H113.094V147.791Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.331 147.791H188.139L193.701 135.16H205.892L200.331 147.791Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.063 168.508H102.74L101.701 155.876H107.063V168.508Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.255 168.508H278.583C278.52 168.295 278.439 168.086 278.239 167.909C277.914 167.629 277.399 167.399 276.589 167.245L275.894 167.152C275.689 167.113 275.394 167.098 275.061 167.094C274.625 167.086 274.255 167.062 273.788 167.062C273.551 167.062 273.289 167.068 272.979 167.087C272.479 167.119 271.964 167.245 271.484 167.475C270.656 167.87 270.24 168.161 269.67 168.49C269.659 168.496 269.65 168.502 269.64 168.508H247.771C246.486 168 244.95 167.502 243.666 167.037C241.611 166.295 239.534 165.613 237.441 164.993C233.251 163.754 228.988 162.76 224.683 162.02C218.461 160.947 212.14 160.406 205.822 160.406C203.65 160.405 201.478 160.469 199.31 160.598C197.657 160.695 195.966 161.634 195.036 163.031C194.858 163.297 194.704 163.578 194.569 163.867C194.098 164.876 193.918 166.008 194.045 167.115C194.1 167.584 194.153 168.048 194.205 168.508H191.21L196.773 155.876H330.25C328.538 159.71 326.851 163.917 325.255 168.508L325.255 168.508ZM179.018 168.508H172.301L177.862 155.876H184.579L179.018 168.508ZM141.027 168.508H113.095V155.876H146.589L141.027 168.508ZM111.483 168.508H107.063V155.876H111.483V168.508Z",
    fill: "#EAECEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.301 168.508H141.027L146.589 155.876H177.862L172.301 168.508Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.094 168.508H111.482V155.876H113.094V168.508Z",
    fill: "#E8E9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.21 168.508H179.018L184.579 155.876H196.772L191.21 168.508Z",
    fill: "#EFEEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.229 117.842H568.451V36.6196H487.229V117.842Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.229 117.842H483.628V36.6196H487.229V117.842Z",
    fill: "#D7D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.233 106.839H557.448V47.6231H498.233V106.839Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.841 97.048L547.657 77.2304L527.841 57.4133L508.024 77.2304L527.841 97.048Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.243 224.64H540.465V143.419H459.243V224.64Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.243 224.64H455.639V143.419H459.243V224.64Z",
    fill: "#D7D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.245 213.637H529.461V154.421H470.245V213.637Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.648 196.653H504.057C508.707 196.653 512.476 192.884 512.476 188.233V179.825C512.476 175.175 508.706 171.406 504.057 171.406H495.648C490.999 171.406 487.229 175.175 487.229 179.825V188.233C487.229 192.884 490.999 196.653 495.648 196.653Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.301 431.142H390.045V264.109H410.301V431.142Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.332 431.142H392.852V436.594H587.332V431.142Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.301 431.142H590.138V264.109H410.301V431.142Z",
    fill: "#F7F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.509 324.063C435.489 324.063 427.337 332.216 427.337 342.234C427.338 352.254 435.489 360.406 445.509 360.406H554.928C564.947 360.406 573.099 352.254 573.099 342.234C573.099 332.216 564.947 324.064 554.927 324.064L445.509 324.063H445.509ZM554.928 361.714H445.509C434.768 361.714 426.029 352.976 426.029 342.234C426.029 331.494 434.768 322.754 445.509 322.754H554.928C565.669 322.754 574.407 331.494 574.407 342.234C574.407 352.975 565.669 361.714 554.928 361.714H554.928Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.509 372.525C435.489 372.525 427.337 380.677 427.337 390.696C427.338 400.715 435.489 408.867 445.509 408.867H554.928C564.947 408.867 573.099 400.715 573.099 390.696C573.099 380.677 564.947 372.525 554.927 372.525H445.509H445.509ZM554.928 410.175H445.509C434.768 410.175 426.029 401.436 426.029 390.695C426.029 379.955 434.768 371.216 445.509 371.216H554.928C565.669 371.216 574.407 379.955 574.407 390.695C574.407 401.436 565.669 410.175 554.928 410.175H554.928Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.729 338.033H483.707C481.472 338.033 479.643 336.205 479.643 333.969C479.643 331.734 481.472 329.905 483.707 329.905L516.729 329.905C518.965 329.905 520.792 331.734 520.792 333.969C520.793 336.205 518.965 338.033 516.729 338.033Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.509 275.603C435.489 275.603 427.337 283.755 427.337 293.773C427.338 303.793 435.489 311.945 445.509 311.945L554.928 311.945C564.947 311.945 573.099 303.793 573.099 293.773C573.099 283.755 564.947 275.603 554.927 275.603H445.509H445.509ZM554.928 313.253H445.509C434.768 313.253 426.029 304.514 426.029 293.773C426.029 283.031 434.768 274.293 445.509 274.293L554.928 274.292C565.669 274.292 574.407 283.031 574.407 293.773C574.407 304.514 565.669 313.253 554.928 313.253H554.928Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.729 289.572H483.707C481.472 289.572 479.643 287.744 479.643 285.508C479.643 283.273 481.472 281.444 483.707 281.444H516.729C518.965 281.444 520.792 283.273 520.792 285.508C520.793 287.744 518.965 289.572 516.729 289.572Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.729 386.495H483.707C481.472 386.495 479.643 384.666 479.643 382.432C479.643 380.195 481.472 378.366 483.707 378.366H516.729C518.965 378.366 520.792 380.195 520.792 382.432C520.793 384.666 518.965 386.495 516.729 386.495Z",
    fill: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.835 255.618H410.301V264.109H593.835V255.618Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.078 255.618H410.301V264.109H386.078V255.618Z",
    fill: "#E0E1E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.853 481.713C591.853 490.051 476.109 496.811 333.333 496.811C190.558 496.811 74.8159 490.051 74.8159 481.713C74.8159 473.375 190.558 466.615 333.333 466.615C476.109 466.615 591.852 473.375 591.853 481.713Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.524 124.368H350.567C350.567 124.368 314.36 157.655 314.36 238.749C314.36 308.442 341.807 402.926 331.505 441.615C323.734 470.799 286.036 475.808 267.98 476.508H459.253C459.253 476.508 522.158 480.304 532.461 441.615C542.762 402.926 515.315 308.442 515.315 238.749C515.315 157.655 551.523 124.368 551.523 124.368H551.524Z",
    fill: "#4078BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.821 476.61C460.948 476.61 459.253 476.508 459.253 476.508H267.98C286.036 475.808 323.733 470.799 331.505 441.615C332.42 438.178 333.037 434.302 333.403 430.038C333.536 430.334 333.669 430.63 333.804 430.925C334.405 432.246 335.427 433.326 336.684 434.008C338.232 441.975 336.619 447.841 338.469 454.979C340.483 462.757 349.243 466.737 349.243 466.737L348.956 463.424L350.314 466.459C350.314 466.459 354.456 460.865 354.455 454.407C354.453 453.272 354.325 452.112 354.024 450.949C352.175 443.811 347.917 439.466 345.403 431.753C346.156 430.577 346.544 429.154 346.421 427.656C344.573 404.835 339.449 382.863 333.555 361.091C329.429 345.607 325.377 330.102 321.224 314.625C317.481 288.576 314.36 262.25 314.36 238.748C314.36 157.654 350.567 124.367 350.567 124.367H551.524C551.524 124.367 539.618 135.313 529.461 159.94C523.859 173.524 518.788 191.267 516.541 213.636C516.184 217.184 515.898 220.857 515.693 224.639C515.447 229.172 515.316 233.872 515.316 238.749C515.316 297.415 534.765 373.651 534.775 419.382C534.775 423.57 534.613 427.501 534.258 431.141C534.072 433.04 533.835 434.859 533.54 436.593C533.522 436.704 533.501 436.816 533.482 436.927C533.195 438.569 532.856 440.132 532.461 441.615C530.496 448.992 526.62 454.824 521.632 459.432C521.511 459.544 521.389 459.655 521.266 459.765C504.325 475.051 475.051 476.611 463.821 476.61V476.61ZM438.667 417.715C438.627 414.742 438.507 411.596 438.293 408.302H353.507C353.681 411.529 353.787 414.675 353.8 417.715H438.667ZM513.667 398.822C513.386 395.768 513.053 392.622 512.693 389.395H352C352.334 392.595 352.627 395.742 352.88 398.822H513.667ZM484.836 379.917C484.435 376.822 484.009 373.675 483.556 370.503H349.693C350.12 373.689 350.534 376.835 350.907 379.917H484.836ZM508.893 361.022C508.44 357.89 507.96 354.755 507.493 351.609H346.987C347.467 354.782 347.92 357.917 348.359 361.022H508.893ZM506.053 342.129C505.573 338.995 505.106 335.849 504.627 332.702H344.134C344.347 334.115 344.56 335.516 344.774 336.916C345.04 338.662 345.307 340.409 345.56 342.129H506.053L506.053 342.129ZM503.213 323.223C502.76 320.089 502.307 316.942 501.867 313.809H341.32C341.774 316.942 342.24 320.076 342.707 323.223H503.213ZM500.56 304.329C500.133 301.182 499.733 298.049 499.358 294.917H338.72C339.12 298.036 339.533 301.182 339.973 304.329H500.56ZM498.239 285.436C497.893 282.289 497.56 279.142 497.266 276.009H336.507C336.827 279.129 337.173 282.276 337.546 285.436H498.239ZM496.466 266.529C496.213 263.369 496.013 260.236 495.853 257.116H334.96C335.134 260.209 335.36 263.356 335.64 266.529H496.467H496.466ZM385.022 247.636C384.928 244.649 384.889 241.676 384.889 238.742V238.222H334.359V238.742C334.359 241.662 334.413 244.623 334.506 247.636H385.022H385.022ZM335.146 219.316C334.88 222.356 334.693 225.504 334.56 228.742H495.506C495.613 225.531 495.773 222.382 495.999 219.316H335.147H335.146ZM359.693 144.369C352.933 153.436 340.679 174.183 336.133 209.836H496.852C499.892 181.849 507.066 160.236 514.599 144.369H359.692H359.693Z",
    fill: "url(#paint0_radial_17386_184)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.853 209.836H336.134C340.68 174.183 352.934 153.436 359.694 144.369H514.6C507.067 160.236 499.894 181.849 496.854 209.836H496.853Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.507 228.742H334.56C334.694 225.504 334.88 222.356 335.147 219.316H496C495.773 222.383 495.613 225.531 495.507 228.742Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.023 247.636H334.507C334.413 244.623 334.359 241.662 334.359 238.742L334.359 238.222H384.89V238.742C384.89 241.675 384.928 244.649 385.023 247.636H385.023Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.467 266.529H335.64C335.36 263.356 335.134 260.209 334.96 257.116H495.854C496.013 260.236 496.214 263.369 496.467 266.529H496.467Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.24 285.436H337.547C337.174 282.276 336.827 279.129 336.507 276.009H497.266C497.56 279.143 497.893 282.289 498.24 285.436Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.56 304.329H339.973C339.533 301.182 339.12 298.036 338.72 294.917H499.358C499.733 298.049 500.133 301.182 500.56 304.329Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.213 323.223H342.707C342.24 320.076 341.773 316.942 341.32 313.809H501.867C502.307 316.942 502.76 320.089 503.213 323.223Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.053 342.129H345.56C345.307 340.409 345.04 338.662 344.773 336.915C344.56 335.515 344.347 334.115 344.133 332.702H504.627C505.107 335.848 505.573 338.995 506.053 342.128L506.053 342.129Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.893 361.022H348.358C347.92 357.917 347.466 354.782 346.986 351.609H507.493C507.96 354.755 508.44 357.89 508.893 361.022Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.836 379.917H350.907C350.534 376.835 350.12 373.688 349.692 370.503H483.556C484.009 373.675 484.434 376.822 484.836 379.917Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.667 398.822H352.88C352.627 395.742 352.333 392.595 352 389.395H512.694C513.053 392.622 513.387 395.769 513.667 398.822Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.666 417.715H353.8C353.787 414.675 353.68 411.529 353.507 408.302H438.293C438.507 411.595 438.626 414.742 438.666 417.715Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.687 466.302C464.484 468.155 454.151 466.74 443.896 466.243C438.978 466.005 434.033 465.986 429.143 466.639C424.353 467.279 419.576 468.526 414.735 468.106C416.334 467.244 417.828 466.228 419.233 465.052C419.543 464.792 419.336 464.33 419.012 464.216C403.96 458.935 390.25 473.321 375.258 469.951C379.502 466.803 385.491 466.74 389.119 462.612C389.4 462.29 389.215 461.765 388.765 461.757C375.334 461.548 362.648 466.755 349.372 467.913C348.737 467.969 348.73 468.971 349.372 468.913C362.243 467.789 374.571 462.876 387.544 462.768C383.67 466.229 377.75 466.357 373.799 469.847C373.512 470.101 373.673 470.588 374.02 470.682C389.131 474.856 402.899 460.434 417.823 464.893C416.257 466.112 414.585 467.138 412.774 467.973C412.398 468.146 412.48 468.818 412.895 468.887C417.813 469.711 422.624 468.661 427.473 467.889C432.917 467.022 438.404 466.977 443.896 467.242C454.25 467.743 464.65 469.137 474.952 467.265C475.584 467.15 475.316 466.186 474.687 466.301L474.687 466.302Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.502 173.566C203.349 174.644 204.422 175.915 205.415 177.087C206.433 178.277 207.48 179.45 208.551 180.598C210.698 182.888 212.87 185.148 215.164 187.235C219.744 191.388 224.659 195.134 229.807 197.501C230.448 197.789 231.089 198.065 231.736 198.297C232.072 198.434 232.363 198.529 232.641 198.614C232.919 198.712 233.207 198.804 233.516 198.869C234.719 199.17 236.037 199.391 237.427 199.478C240.213 199.631 243.217 199.445 246.25 198.975C249.29 198.53 252.369 197.839 255.444 197.024C258.502 196.223 261.639 195.231 264.566 194.204L267.262 199.49C261.287 203.166 255.086 206.021 248.2 207.967C244.767 208.916 241.161 209.6 237.32 209.722C235.398 209.78 233.402 209.688 231.361 209.325C230.855 209.249 230.34 209.136 229.823 209.005C229.296 208.885 228.792 208.753 228.349 208.607C227.416 208.336 226.511 208.017 225.62 207.681C218.511 204.927 212.595 200.703 207.273 196.104C204.625 193.782 202.074 191.387 199.711 188.823C198.525 187.545 197.367 186.245 196.236 184.918C195.081 183.568 194.048 182.28 192.892 180.719L202.503 173.567L202.502 173.566Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.952 169.8C188.658 177.268 191.554 190.724 191.554 190.724L210.037 188.485C210.037 188.485 210.714 168.787 207.133 164.026C201.115 156.026 189.229 162.746 188.952 169.8Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.158 196.136L270.819 188.216L271.92 196.744C271.92 196.744 268.333 201.551 264.265 199.531L262.158 196.136Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.163 188.676L278.83 193.482L271.921 196.744L270.819 188.216L275.163 188.676Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.979 167.086C273.896 167.032 274.402 167.084 275.061 167.094C275.394 167.098 275.689 167.113 275.894 167.152L276.588 167.245C277.399 167.399 277.913 167.629 278.239 167.909C278.558 168.19 278.575 168.551 278.695 168.883L279.004 169.894L280.242 173.944L282.715 182.039L287.662 198.233C290.929 209.037 294.328 219.805 297.478 230.638C303.947 252.263 310.073 273.975 316.084 295.719C322.088 317.462 327.749 339.296 333.555 361.091C339.45 382.863 344.574 404.835 346.422 427.656C346.718 431.299 344.005 434.489 340.362 434.785C337.51 435.017 334.927 433.389 333.805 430.925C324.341 410.078 318.15 388.382 312.731 366.486C307.226 344.613 301.571 322.778 296.263 300.854C290.959 278.927 285.771 256.973 280.926 234.927C278.421 223.927 276.163 212.862 273.773 201.832L270.235 185.273L268.466 176.994L267.582 172.855L267.359 171.82C267.304 171.471 267.143 171.148 267.285 170.746C267.433 170.344 267.772 169.892 268.406 169.364L268.969 168.945C269.131 168.812 269.379 168.657 269.669 168.49C270.24 168.161 270.656 167.87 271.484 167.475C271.964 167.245 272.478 167.119 272.979 167.086H272.979Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.151 430.948C344.925 430.202 344.168 429.748 343.413 429.943L340.479 430.703L337.544 431.464C336.789 431.659 336.348 432.424 336.514 433.186C338.346 441.576 336.556 447.597 338.469 454.979C340.482 462.757 349.242 466.737 349.242 466.737L348.956 463.424L350.314 466.459C350.314 466.459 356.038 458.727 354.024 450.95C352.112 443.567 347.622 439.173 345.15 430.948H345.151Z",
    fill: "#4078BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.242 466.738C349.242 466.738 340.482 462.758 338.469 454.979C336.555 447.598 338.346 441.576 336.514 433.187C336.49 433.079 336.48 432.972 336.478 432.867C336.478 432.221 336.894 431.631 337.543 431.464L340.478 430.703L343.413 429.943C343.532 429.912 343.65 429.897 343.768 429.897C344.393 429.897 344.961 430.319 345.15 430.948C347.622 439.173 352.112 443.567 354.024 450.95C354.325 452.112 354.453 453.273 354.454 454.407C354.456 460.866 350.314 466.459 350.314 466.459L348.956 463.425L349.242 466.738Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.432 450.224C347.686 451.206 347.097 452.207 346.116 452.462C345.135 452.717 344.133 452.127 343.879 451.146C343.625 450.165 344.213 449.163 345.195 448.908C346.177 448.654 347.178 449.243 347.432 450.224Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.06 463.827C348.837 463.886 348.61 463.753 348.553 463.53L345.252 450.789C345.194 450.568 345.328 450.341 345.55 450.282C345.773 450.224 346 450.359 346.057 450.581L349.358 463.321C349.416 463.543 349.282 463.77 349.06 463.828V463.827Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.264 385.15L320.296 389.806C319.263 390.073 318.199 389.448 317.931 388.415C317.664 387.382 318.29 386.318 319.322 386.051L337.293 381.395C338.325 381.127 339.388 381.754 339.656 382.786C339.923 383.82 339.298 384.884 338.264 385.15H338.264Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.032 141.131C246.712 141.933 246.875 142.767 247.399 142.994C247.923 143.221 248.609 142.755 248.93 141.953C249.251 141.152 249.087 140.317 248.565 140.091C248.041 139.864 247.355 140.329 247.032 141.131Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.314 140.035L250.462 140.314C250.462 140.314 248.871 141.391 248.314 140.035Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.395 142.203C247.395 142.203 247.37 146.244 248.197 148.557C246.745 149.086 245.128 147.856 245.128 147.856L247.394 142.203H247.395Z",
    fill: "#F68D53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.255 136.252L250.032 136.14C248.301 134.65 246.497 135.085 246.42 135.105C246.148 135.175 245.87 135.011 245.801 134.74C245.731 134.468 245.891 134.19 246.162 134.119C246.259 134.094 248.544 133.515 250.697 135.367C250.912 135.552 250.936 135.873 250.752 136.085C250.626 136.233 250.432 136.291 250.255 136.252V136.252Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.761 140.718C219.339 147.203 217.168 157.837 212.266 161.456C212.266 161.456 215.959 168.282 227.787 169.869C240.792 171.615 234.683 164.294 234.683 164.294C227.763 161.66 228.501 156.456 230.258 151.713L218.761 140.717V140.718Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.193 175.364C255.209 181.427 256.476 187.704 257.8 193.818C258.501 196.879 259.215 199.937 260.043 202.942C260.807 205.974 261.693 208.945 262.618 211.891C263.117 213.337 263.569 214.818 264.102 216.239L264.903 218.371L265.098 218.894L265.145 219.047L265.244 219.29C265.361 219.549 265.652 219.93 266.497 220.265C267.311 220.59 268.484 220.803 269.769 220.889C272.362 221.035 275.337 220.708 278.301 220.191C281.255 219.667 284.358 218.945 287.25 218.138L289.694 223.545C288.162 224.465 286.704 225.204 285.162 225.943C283.636 226.683 282.07 227.351 280.455 227.948C277.218 229.134 273.837 230.124 269.984 230.446C268.054 230.599 265.979 230.574 263.691 230.018C261.454 229.486 258.787 228.225 256.91 225.932C256.435 225.378 256.034 224.775 255.678 224.164C255.498 223.857 255.35 223.546 255.192 223.233L254.927 222.639L253.891 220.305C253.206 218.748 252.61 217.181 251.986 215.612C250.839 212.462 249.748 209.302 248.793 206.128C247.835 202.946 247.006 199.753 246.192 196.555C244.595 190.128 243.309 183.774 242.34 177.114L254.192 175.364H254.193Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.927 218.512L291.074 214.429L293.386 222.36C293.386 222.36 286.344 227.45 284.463 221.463L285.927 218.512Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.715 215.84L297.556 221.619L293.386 222.36L291.074 214.429L295.715 215.84Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.556 469.944L210.314 470.736L213.51 446.033L202.751 445.239L199.556 469.944Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.657 438.557L139.977 444.224L155.477 424.862L146.157 419.195L130.657 438.557Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.15 444.054C144.275 445.649 145.358 446.595 146.096 446.611C146.4 446.618 146.658 446.47 146.882 446.155C147.003 445.986 146.98 445.868 146.949 445.784C146.682 445.106 144.683 444.422 143.15 444.054ZM146.475 447.074C146.352 447.108 146.222 447.125 146.086 447.121C144.715 447.091 143.167 445.03 142.364 443.806L142.367 443.523L142.63 443.417C143.067 443.503 146.917 444.312 147.422 445.598C147.535 445.884 147.492 446.179 147.297 446.453C147.063 446.778 146.789 446.986 146.475 447.074Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.111 443.503C144.413 443.644 146.499 443.268 146.902 442.644C146.969 442.541 147.018 442.39 146.804 442.128C146.632 441.917 146.413 441.81 146.136 441.798C145.204 441.76 143.855 442.817 143.112 443.503L143.111 443.503ZM145.907 443.742C144.748 444.069 143.246 444.108 142.513 443.912L142.334 443.734L142.396 443.489C142.484 443.397 144.602 441.225 146.154 441.29C146.58 441.306 146.931 441.48 147.198 441.806C147.614 442.311 147.459 442.723 147.33 442.922C147.092 443.29 146.554 443.561 145.907 443.742V443.742Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.773 442.146L133.931 433.634C133.61 433.325 133.14 433.29 132.801 433.552L125.257 439.374C124.475 439.978 124.456 441.246 125.21 441.947C128.343 444.864 129.996 446.118 133.885 449.862C136.277 452.165 139.539 455.771 142.843 458.951C146.074 462.062 149.374 459.13 148.275 457.518C143.347 450.291 144.083 447.578 143.636 443.883C143.555 443.217 143.243 442.599 142.772 442.146H142.773Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.459 470.339C214.833 470.734 216.602 470.63 217.271 470.045C217.507 469.837 217.611 469.568 217.589 469.222C217.582 469.09 217.534 469.01 217.435 468.953C216.725 468.555 214.249 469.492 212.459 470.34V470.339ZM214.985 471.086C213.801 471.086 212.517 470.884 211.606 470.702L211.405 470.487L211.539 470.224C212.033 469.972 216.397 467.775 217.686 468.51C217.937 468.651 218.08 468.886 218.098 469.188C218.132 469.696 217.966 470.114 217.606 470.427C217.042 470.922 216.054 471.086 214.985 471.086V471.086Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.338 466.343C212.786 466.343 212.173 468.899 211.983 469.992C213.323 469.192 215.094 467.36 214.977 466.631C214.969 466.574 214.939 466.396 214.486 466.351L214.338 466.343L214.338 466.343ZM211.657 470.706L211.507 470.658L211.403 470.425C211.423 470.233 211.919 465.834 214.328 465.834L214.538 465.844C215.235 465.916 215.434 466.268 215.48 466.552C215.675 467.766 213.072 470.099 211.759 470.685L211.656 470.706L211.657 470.706Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.986 469.205H198.894C198.454 469.205 198.087 469.511 198.015 469.941L196.393 479.508C196.223 480.501 197.053 481.439 198.068 481.422C202.286 481.35 204.324 481.102 209.642 481.102C212.913 481.102 219.672 481.442 224.191 481.442C228.608 481.442 229.063 476.975 227.192 476.57C218.804 474.755 215.548 472.254 212.766 469.867C212.265 469.436 211.629 469.204 210.985 469.204L210.986 469.205Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.518 454.735H201.523L201.103 457.989H201.098L201.518 454.735Z",
    fill: "#C2C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.733 459.768L201.103 457.989L201.523 454.735L212.205 456.115L211.733 459.768Z",
    fill: "#DA9164"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.541 427.458L139.535 427.456L141.385 425.147L141.39 425.15L139.541 427.458Z",
    fill: "#C2C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.059 432.877L139.542 427.458L141.39 425.15L150.97 430.491L149.059 432.877Z",
    fill: "#DA9164"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.131 226.276C202.552 227.401 220.418 229.802 237.696 232.128C254.574 171.034 249.599 169.361 249.596 169.359C248.266 168.563 245.661 167.759 243.665 167.037C241.611 166.295 239.533 165.613 237.44 164.993C233.251 163.754 228.988 162.76 224.683 162.02C216.319 160.577 207.781 160.097 199.309 160.598C197.656 160.695 195.965 161.634 195.035 163.031C194.857 163.297 194.703 163.578 194.568 163.867C194.097 164.876 193.917 166.008 194.044 167.115C197.76 199.257 196.573 209.83 194.131 226.276L194.131 226.276Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.321 193.531C247.838 191.048 248.271 188.821 248.633 186.821C248.273 188.82 247.84 191.048 247.321 193.531Z",
    fill: "#DA9164"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.295 206.825C242.931 203.54 240.744 196.63 241.939 188.101C242.698 182.69 245.72 181.197 248.802 181.197C249.047 181.197 249.294 181.206 249.539 181.224C249.309 182.855 249.011 184.712 248.632 186.821C248.271 188.82 247.837 191.047 247.32 193.53C246.525 197.332 245.531 201.733 244.295 206.824L244.295 206.825Z",
    fill: "#A1A62E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.219 169.18C256.678 173.455 261.862 183.625 263.426 189.535L247.538 204.093C247.538 204.093 239.296 184.932 239.959 178.977C240.631 172.952 246.398 167.564 249.219 169.18V169.18Z",
    fill: "#D6DC40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.118 127.31C217.773 137.419 216.141 141.617 219.083 148.825C223.507 159.666 236.619 161.952 242.909 153.141C248.57 145.212 253.089 130.016 245.031 121.924C237.093 113.95 224.463 117.204 221.119 127.31L221.118 127.31Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.694 136.277C236.938 138.06 236.935 140.281 237.374 142.076C238.035 144.775 240.05 144.964 241.275 143.243C242.378 141.695 243.363 138.424 242.023 136.183C240.701 133.975 238.557 134.238 237.694 136.277Z",
    fill: "#F9AD7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.742 114.73C217.55 110.73 204.592 122.434 201.334 141.543C199 155.228 228.215 161.841 246.663 161.619C245.444 158.396 237.778 148.689 242.671 139.349C246.226 132.56 250.282 134.126 250.545 126.23C250.877 116.286 237.703 109.619 224.742 114.73V114.73Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.139 119.026C249.506 118.212 257.925 126.434 251.674 134.636C251.674 134.636 247.111 130.581 240.691 131.989C236.871 132.826 241.139 119.026 241.139 119.026V119.026Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.195 230.581C226.195 230.581 209.28 302.081 201.375 343.153C193.032 386.487 153.015 431.631 153.015 431.631L139.422 424.053C139.422 424.053 164.602 382.845 172.771 342.383C189.355 260.249 178.128 243.705 194.133 226.278L226.195 230.581Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.36 432.908L137.391 423.446L139.869 418.433L158.906 427.191L154.36 432.908Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.852 316.324C205.877 303.387 204.879 279.281 209.056 262.264C210.03 271.761 211.035 282.434 211.875 293.21C210.17 300.914 208.463 308.746 206.853 316.324H206.852Z",
    fill: "#28343A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.05 232.162C237.05 232.162 244.661 317.043 240.508 349.422C236.191 383.101 214.214 456.374 214.214 456.374L198.696 454.371C198.696 454.371 211.303 381.762 213.543 348.418C215.986 312.068 205.146 227.881 205.146 227.881L237.05 232.163V232.162Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.513 457.259L195.398 454.405L195.738 447.871L219.731 450.198L217.513 457.259Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.75 223.652L191.376 227.26C191.192 227.54 191.518 227.893 192.021 227.961L237.711 234.093C238.103 234.146 238.45 233.998 238.5 233.757L239.304 229.938C239.359 229.672 239.043 229.401 238.614 229.343L194.496 223.422C194.171 223.378 193.87 223.471 193.75 223.651V223.652Z",
    fill: "#4078BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.868 234.104C237.817 234.104 237.764 234.101 237.711 234.093L237.213 234.026L205.383 229.754L192.021 227.961C191.614 227.906 191.322 227.665 191.323 227.426C191.323 227.369 191.341 227.313 191.375 227.26L193.75 223.652C193.851 223.501 194.076 223.412 194.337 223.412C194.39 223.412 194.441 223.416 194.495 223.423L238.613 229.344C239.009 229.397 239.309 229.632 239.309 229.877C239.309 229.897 239.308 229.918 239.304 229.938L238.5 233.757C238.456 233.965 238.191 234.104 237.868 234.104H237.868Z",
    fill: "#44377C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.157 229.344L197.974 229.185C197.741 229.155 197.574 229.009 197.604 228.864L198.694 223.909C198.724 223.764 198.943 223.672 199.179 223.702L200.36 223.862C200.595 223.893 200.761 224.037 200.731 224.182L199.642 229.139C199.61 229.283 199.391 229.376 199.156 229.344H199.157Z",
    fill: "#2C3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.998 233.418L227.816 233.26C227.582 233.228 227.415 233.084 227.447 232.938L228.535 227.984C228.567 227.839 228.786 227.746 229.021 227.777L230.202 227.936C230.438 227.968 230.604 228.112 230.572 228.257L229.484 233.211C229.452 233.357 229.233 233.449 228.998 233.418Z",
    fill: "#2C3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17386_184",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(409.752 300.489) rotate(90) scale(176.121 141.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7571AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3E86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17386_184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 666.667,
    height: 496.811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulherCaneta);
export default __webpack_public_path__ + "static/media/mulherCaneta.9d4b4934e6713fba9d529ad2e8b994c4.svg";
export { ForwardRef as ReactComponent };